import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { useForm, useAuthStore } from "hooks";
import Swal from "sweetalert2";

export interface PageForgotPasswordProps {
  className?: string;
}

const loginFormFields = {
  loginEmail: "",
  loginPassword: "",
};

const inputDark =
  "w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-white placeholder-slate-500 transition focus:border-violet-500 focus:outline-none focus:ring-2 focus:ring-violet-500/30";
const labelDark = "mb-1.5 block text-sm font-medium text-slate-300";
const btnGradient =
  "inline-flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r from-violet-600 to-fuchsia-600 px-7 py-3 text-base font-bold uppercase tracking-wide text-white shadow-lg shadow-violet-600/30 transition-all duration-200 hover:from-violet-500 hover:to-fuchsia-500 hover:shadow-violet-500/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 active:scale-95 disabled:opacity-70";

const PageForgotPassword = ({ className }: PageForgotPasswordProps) => {
  const { requestPasswordReser, errorMessage } = useAuthStore();
  const [openModal, setOpenModal] = useState(false);
  const { loginEmail, onInputChange } = useForm(loginFormFields);
  const [hiddenForm, setHiddenForm] = useState(true);

  const handleCloseModal = () => {
    setOpenModal(false);
    setHiddenForm(false);
  };

  useEffect(() => {
    if (errorMessage !== undefined) {
      Swal.fire("Error en la autenticación", errorMessage, "error");
    }
  }, [errorMessage]);

  const handleResetPasswd = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      requestPasswordReser({ email: loginEmail });
      setOpenModal(true);
    } catch (error) {
      console.log("Error en el login", error);
    }
  };

  return (
    <div className={`nc-PageForgotPassword relative min-h-screen overflow-hidden bg-gradient-to-b from-[#0c0a16] to-[#15101f] px-4 py-16 ${className}`} data-nc-id="PageForgotPassword">
      <Helmet>
        <title>Recuperar contraseña · Karaoke Room Barcelona</title>
      </Helmet>
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-0 h-80 w-80 -translate-x-1/2 rounded-full bg-violet-600/20 blur-[120px]" />
      </div>

      <div className="relative mx-auto max-w-md">
        <div className="flex flex-col items-center text-center">
          <h1 className="text-3xl font-bold uppercase tracking-wide text-white sm:text-4xl">Recuperar contraseña</h1>
          <div className="mt-3 h-1 w-20 rounded-full bg-gradient-to-r from-violet-500 to-fuchsia-500" />
          <p className="mt-4 max-w-sm text-sm text-slate-400">Introduce tu correo y te enviaremos los pasos para restablecer tu contraseña.</p>
        </div>

        <div className="mt-10 rounded-3xl border border-white/10 bg-white/[0.04] p-6 shadow-2xl backdrop-blur-xl sm:p-8">
          {hiddenForm ? (
            <form className="grid grid-cols-1 gap-5" onSubmit={handleResetPasswd}>
              <div>
                <label htmlFor="loginEmail" className={labelDark}>Correo electrónico</label>
                <input id="loginEmail" type="email" placeholder="ejemplo@ejemplo.com" name="loginEmail" value={loginEmail} onChange={onInputChange} required className={inputDark} />
              </div>
              <button type="submit" className={btnGradient}>Enviar</button>
            </form>
          ) : (
            <div className="flex items-center justify-center">
              <Link to="/login" className="font-semibold text-violet-300 hover:text-violet-200">Ir a login</Link>
            </div>
          )}
        </div>
      </div>

      {openModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
          <div className="modal-content w-full max-w-sm rounded-2xl border border-white/10 bg-[#15101f]/95 p-6 text-center shadow-2xl backdrop-blur-xl">
            <p className="text-slate-200">Si tu email está registrado, recibirás un correo con los pasos a seguir.</p>
            <button onClick={handleCloseModal} className={`${btnGradient} mt-6`}>Cerrar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PageForgotPassword;
